import { graphql, useStaticQuery } from 'gatsby';

type FooterQuery = Queries.NavigationBarFragment & {
  footerDescription: string;
  footerEmailInputPlaceholder: string;
  footerHeadline: {
    childMarkdownRemark: {
      html: string;
    };
  };
};

const useFooterQuery = (): FooterQuery => {
  const data = useStaticQuery(graphql`
    query Footer {
      pages: contentfulNavigationBar(slug: { eq: "footer" }) {
        ...NavigationBar
        footerDescription
        footerEmailInputPlaceholder
        footerHeadline {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  `);

  return data.pages;
};

export default useFooterQuery;
